function parallaxInit(parallaxElements, intensity) {
  if (
    "IntersectionObserver" in window &&
    "IntersectionObserverEntry" in window
  ) {
    // Intersection Observer Configuration
    const observerOptions = {
      root: null,
      threshold: 0,
    };

    var observer = new IntersectionObserver(handleIntersect, observerOptions);
    var el;
    function handleIntersect(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          el = entry.target;
          // console.log(el, "intersecting");
          window.addEventListener("scroll", parallax, false);
        } else {
          // window.removeEventListener("scroll", parallax, false);
          window.addEventListener("scroll", parallax, false);
        }
      });
    }

    parallaxElements.forEach(function (parallaxElement) {
      observer.observe(parallaxElement);
    });

    var parallax = debounce(function () {
      if (el) {
        amount =
          (intensity * el.getBoundingClientRect().y) / window.innerHeight;

        var pos = el.getBoundingClientRect().top;
        // if an element is more or less in the middle of the viewport

        for (const item of el.querySelectorAll(".parallax__item")) {
          if (
            pos > window.innerHeight / 1.5 &&
            pos < window.innerHeight / 0.5
          ) {
            item.style.opacity = 0.2;
            item.style.transition = "opacity 1.2s linear";
            //return false; // stop iteration
          } else {
            item.style.opacity = 1;
            item.style.transition = "opacity 1.2s linear";
          }
        }

        if (el.getBoundingClientRect().y > 0 || (amount < -10 && amount > 10)) {
          //console.log(amount);
          const leftItems = el.getElementsByClassName("parallax__left-item");

          if (leftItems.length > 0) {
            for (let i = 0; i < leftItems.length; i++) {
              if (i == 0) {
                leftItems[i].style.webkitTransform =
                  "translateY(" + amount + "px)";
              } else {
                leftItems[i].style.webkitTransform =
                  "translateY(" + amount / (i * 0.8) + "px)";
              }
            }

            // console.log(leftItems.indexOf(item));
          }

          const rightItems = el.getElementsByClassName("parallax__right-item");
          if (rightItems.length > 0) {
            for (let i = 0; i < leftItems.length; i++) {
              if (i == 0) {
                rightItems[i].style.webkitTransform =
                  "translateY(" + (0 - amount) + "px)";
              } else {
                rightItems[i].style.webkitTransform =
                  "translateY(" + (0 - amount / (i * 0.8)) + "px)";
              }
            }
          }
        }
      }
    }, 0.1);
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
